export const COURSE_TITLE_CHANGED = 'COURSE_TITLE_CHANGED';
export const COURSE_SUBJECT_CHANGED = 'COURSE_SUBJECT_CHANGED';
export const COURSE_NUMBER_CHANGED = 'COURSE_NUMBER_CHANGED';
export const COURSE_UNIVERSITY_CHANGED = 'COURSE_UNIVERSITY_CHANGED';
export const CLEAR_COURSE_FIELDS = 'CLEAR_COURSE_FIELDS';



// WEBPACK FOOTER //
// ./src/modules/courses/components/AddCourse/action_types.js